const dictionaryActionTypes = {
  STORE_STATIC_DICTIONARIES: 'STORE_STATIC_DICTIONARIES',
  STORE_BIG_STATIC_DICTIONARIES: 'STORE_BIG_STATIC_DICTIONARIES',
};

export default dictionaryActionTypes;
